import { IQuadTriggerRuleSettingsModel, ITriggerRuleSettingsModel } from '../../interfaces/ITriggerRule';
import { useMutation } from 'react-query';
import ApiClient from '../../services/apiClient';


export const useQuadCreateTriggerMutation = (onError: (errorMessage: string) => void) => {
    const _apiClient = new ApiClient();
    return useMutation({
        mutationFn: async (newTrigger: IQuadTriggerRuleSettingsModel) => {
            const response = await _apiClient.createQuadTrigger(newTrigger);
            if (!response?.httpResponse.ok) {
                if (response.httpResponse.status === 400
                ) {
                    throw new Error(`Failed to create quad Trigger : ${response.errorMessage}`);
                }
                else if (response.httpResponse.status === 403
                ) {
                    throw new Error(`Forbidden to create quad trigger`);
                }
                throw new Error('Failed to create quad Trigger');
            }
            return response.payload;
        },
        onError(error) {
            if (error instanceof Error) {
                onError(error.message);
            }
        },
    });

}
    